
import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { FlatTourData } from '@/utils/tourTransformUtils';

interface TourDescriptionProps {
  tour: FlatTourData;
}

export const TourDescription: React.FC<TourDescriptionProps> = ({ tour }) => {
  const { language } = useLanguage();
  
  // Only render if there's a description
  if (!tour.description) {
    return null;
  }
  
  return (
    <div className="bg-white p-6 rounded-xl shadow-sm mb-8">
      <h2 className="section-title mb-4">
        {language === 'en' ? 'About this tour' : 'אודות הסיור'}
      </h2>
      <p className="text-gray-700 leading-relaxed text-lg">
        {tour.description}
      </p>
    </div>
  );
};
